import React, { useRef } from 'react';
import LoadingBar from 'react-top-loading-bar';
import { useAppSelector } from '../store/hooks';

export const TopLoadingBar = () => {
  const loadingBarRef = useRef(null);
  const isLoading = useAppSelector(state => state.ui.loading);

  React.useEffect(() => {
    if (isLoading) {
      loadingBarRef.current?.continuousStart();
    } else {
      loadingBarRef.current?.complete();
    }
  }, [isLoading]);

  return (
    <LoadingBar
      color="#2998ff"
      ref={loadingBarRef}
      shadow={true}
    />
  );
};

export default TopLoadingBar;
